export class MyGameInputModel {
    hitType: any;
    hitRange: any;
    hitLevel: any;
    gameType: any;
    userRole: any;
}
